(() => {
  function initializeNavigation() {
    document.querySelectorAll('[data-buyback-navigation]').forEach((navigation) => {
      if (navigation.dataset.initialized) return;
      navigation.dataset.initialized = 'true';
      const toggle = navigation.querySelector('[data-menu-open]');
      const drawer = navigation.querySelector('.site-nav-drawer');
      const closeButton = drawer.querySelector('.site-nav-drawer__close');
      const close = () => {
        drawer.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      };
      toggle.addEventListener('click', () => {
        drawer.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        closeButton.focus();
      });
      drawer.querySelectorAll('[data-menu-close]').forEach((button) => {
        button.addEventListener('click', close);
      });
      navigation.addEventListener('keydown', (event) => {
        if (drawer.hidden) return;
        if (event.key === 'Escape') close();
        if (event.key !== 'Tab') return;
        const links = [...drawer.querySelectorAll('button, a[href]')];
        const first = links[0];
        const last = links[links.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    });
    const navigation = document.querySelector('[data-buyback-navigation]');
    document.documentElement.style.setProperty('--mp-header-height', `${navigation?.offsetHeight ?? 0}px`);
  }
  initializeNavigation();
  window.addEventListener('resize', initializeNavigation);
  document.addEventListener('shopify:section:load', initializeNavigation);
})();
